/**
 * SME marketing plan caps — mirrors RecruiterAI-BE billing-config v3.5 SSOT.
 * Used on the public landing compare table (not fetched from API).
 */
export type MarketingPlanId =
  | 'freemium_trial'
  | 'sme_starter'
  | 'sme_growth'
  | 'sme_professional';

export interface MarketingPlanLimits {
  positions: number;
  candidates: number;
  aiCompany: number;
  seats: number;
}

export interface MarketingPlanDescriptor {
  planId: MarketingPlanId;
  priceMonthly: number;
  trialDays?: number;
  limits: MarketingPlanLimits;
}

export const MARKETING_RECOMMENDED_PLAN: MarketingPlanId = 'sme_growth';

export const MARKETING_SME_PLANS: MarketingPlanDescriptor[] = [
  {
    planId: 'freemium_trial',
    priceMonthly: 0,
    trialDays: 7,
    limits: { seats: 1, positions: 2, candidates: 25, aiCompany: 25 },
  },
  {
    planId: 'sme_starter',
    priceMonthly: 99,
    limits: { seats: 3, positions: 5, candidates: 300, aiCompany: 150 },
  },
  {
    planId: 'sme_growth',
    priceMonthly: 249,
    limits: { seats: 10, positions: 10, candidates: 1500, aiCompany: 500 },
  },
  {
    planId: 'sme_professional',
    priceMonthly: 449,
    limits: { seats: 25, positions: 50, candidates: 5000, aiCompany: 1500 },
  },
];

export const MARKETING_PLAN_LABEL: Record<MarketingPlanId, string> = {
  freemium_trial: 'Trial',
  sme_starter: 'Starter',
  sme_growth: 'Growth',
  sme_professional: 'Professional',
};
